// The player actions an action point can be spent on. Modelled as a
// discriminated union on `type`, so a handler can switch exhaustively.
//
// CORE actions are always available; SPECIAL actions are granted by Fortress
// card effects and listed per-player in `Player.actions`. `cardId` on a special
// action identifies the implemented Fortress card whose effect is being used.
// --- Core actions ---------------------------------------------------------
export const ACTION_KINDS = [
    "construct_building",
    "construct_bridge",
    "implement_fortress",
    "aim_barracks",
    "cycle_market",
];
// --- Special actions (granted by Fortress effects) ------------------------
export const SPECIAL_ACTION_KINDS = [
    "pay_penalty_with_token",
    "make_scout_indestructible",
    "replicate_fortress",
    "double_banked_resources",
    "collect_card_energy",
    "untap_barracks",
    "set_fortress_lock",
    "free_cycle_market",
    "reorder_fortress_deck",
    "buy_extra_action",
    "force_end_round",
    "adjust_fortress_token",
    "rejoin_round",
    "move_fortress",
    "claim_resources",
    "free_build",
    "free_bridge",
    "sell_building",
    "tutor_market_card",
    "copy_fortress_effect",
    "mark_fortresses",
    "move_building",
    "bank_two_resources",
    "pick_bonus_resources",
    "drop_one_time_resources",
    "designate_attack_target",
    "bank_production_reset",
    "spend_token_for_action",
    "redistribute_resources",
    "gain_free_action",
    "mineral_windfall",
    "market_reaction",
    "redistribute_tokens",
    "adjust_fortress_tokens",
    // Carried by an ordinary `implement_fortress` whose `fromDiscard` names the
    // granting card — no action of this type is ever sent; the kind exists so
    // the grant is listed, gated (`canUseCardAction`) and budgeted like any
    // other.
    "implement_from_discard",
    "shuffle_discard_into_deck",
];
/** All action kinds, core + special. */
export const ALL_ACTION_KINDS = [
    ...ACTION_KINDS,
    ...SPECIAL_ACTION_KINDS,
];
// --- Queued moves -----------------------------------------------------------
/** How many of a player's upcoming turns can hold queued moves (1 = next
 * turn, up to this many turns ahead). */
export const MAX_QUEUE_TURNS = 3;
/** Cap on queued moves per turn slot — bounded so state can't grow unchecked
 * (generous vs. the usual 2 actions; extras beyond the turn's action points
 * are discarded when the turn ends). */
export const MAX_QUEUED_MOVES_PER_TURN = 6;
// --- Match restore (creator rollback) ---------------------------------------
/**
 * How far back the creator may roll a live match: restore points older than
 * this many turns behind the current one are pruned (from the synced index,
 * the room's blob ring, and the snapshot collection alike).
 *
 * Counted in GLOBAL turns, the same counter `GameState.turnNumber` carries —
 * so in a 4-player match this is roughly five rounds, and in a 2-player one
 * roughly ten.
 */
export const RESTORE_WINDOW_TURNS = 20;
/** Queue-only pseudo-move: when the turn it's queued for starts, the player
 * passes for the rest of the round, exactly as if they pressed Pass live. Not
 * a `GameAction` — it never routes through `dispatchAction`; the queued-move
 * executor applies it after the slot's real moves have played. It always ends
 * a slot's plan: queueing anything after it is rejected. */
export const QUEUED_PASS_TYPE = "pass";
//# sourceMappingURL=actions.js.map